import React, { useState } from 'react'
import { Card, Button, Badge, Row, Col } from 'react-bootstrap'
export default function Subscription({ state, onPlanChange, onCancelSubscription }) {
  const { currentPlan, status, renewalDate } = state
  return (
    <div className='subscription_management'>
      <div className='mt-4'>
        <h2 className='fw-bold h4 mb-4'>Current Plan</h2>
        <Card className='mb-5'>
          <Card.Body className='d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center'>
            <div>
              <h3 className='h5 fw-semibold'>
                {currentPlan === 'pro' ? 'Fleet Owner Pro' : 'Single Owner'}
              </h3>
              <p className='small text-muted mb-1'>
                Your plan renews on <span className='fw-bold text-dark'>{renewalDate}</span>.
              </p>
              <p className='small text-muted mb-0'>
                You are currently on the{' '}
                <Badge bg={status === 'active' ? 'success' : 'danger'}>
                  {status === 'active' ? 'Active' : 'Pending Cancellation'}
                </Badge>{' '}
                plan.
              </p>
            </div>
            <div className='mt-3 mt-sm-0 d-flex'>
              <Button
                variant='primary'
                className='me-2'
                onClick={() => onPlanChange(currentPlan === 'pro' ? 'single' : 'pro')}
              >
                {currentPlan === 'pro' ? 'Downgrade Plan' : 'Upgrade Plan'}
              </Button>
              {status === 'active' && (
                <Button variant='outline-primary' onClick={onCancelSubscription}>
                  Cancel Subscription
                </Button>
              )}
            </div>
          </Card.Body>
        </Card>

        <h2 className='fw-bold h4 mb-4'>Change Plan</h2>
        <Row>
          <Col md={6} className='mb-3'>
            <Card className={`h-100 ${currentPlan === 'single' ? 'plan-card-highlight' : ''}`}>
              <Card.Body className='d-flex flex-column'>
                <div className='d-flex justify-content-between align-items-center mb-3'>
                  <h3 className='h5 fw-semibold'>Single Owner</h3>
                  <p className='h3 fw-bold text-primary-orange m-0'>
                    $17<span className='h6 text-muted fw-normal'>/month</span>
                  </p>
                </div>
                <ul className='list-unstyled text-muted small mb-4 flex-grow-1'>
                  <li className='mb-2'>✓ Free setup and support</li>
                  <li className='mb-2'>✓ Real-time job updates</li>
                  <li className='mb-2'>✓ Effortless document scanning</li>
                  <li className='mb-2'>✓ Automated job reports</li>
                </ul>
                {currentPlan === 'pro' ? (
                  <Button
                    variant='primary'
                    className='w-100'
                    onClick={() => onPlanChange('single')}
                  >
                    Downgrade to this Plan
                  </Button>
                ) : (
                  <div className='text-center text-muted fw-medium py-2 px-4 rounded-pill bg-light'>
                    Current Plan
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} className='mb-3'>
            <Card className={`h-100 ${currentPlan === 'pro' ? 'plan-card-highlight' : ''}`}>
              <Card.Body className='d-flex flex-column'>
                <div className='d-flex justify-content-between align-items-center mb-3'>
                  <h3 className='h5 fw-semibold'>Fleet Owner Pro</h3>
                  <p className='h3 fw-bold text-primary-orange m-0'>
                    $39<span className='h6 text-muted fw-normal'>/month</span>
                  </p>
                </div>
                <ul className='list-unstyled text-muted small mb-4 flex-grow-1'>
                  <li className='mb-2'>✓ Centralized platform for all fleet data</li>
                  <li className='mb-2'>✓ Automated alerts for compliance</li>
                  <li className='mb-2'>✓ Streamlined dispatching</li>
                  <li className='mb-2'>✓ Simplified invoicing</li>
                </ul>
                {currentPlan === 'single' ? (
                  <Button variant='primary' className='w-100' onClick={() => onPlanChange('pro')}>
                    Upgrade to this Plan
                  </Button>
                ) : (
                  <div className='text-center text-muted fw-medium py-2 px-4 rounded-pill bg-light'>
                    Current Plan
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}
